module.exports = __webpack_public_path__ + "24d2858b1e52644487271fb0cae4f310.png";